import React from "react";
import { MessageCircle } from "lucide-react";
import { brand } from "../mock";

const WhatsAppFloat = () => {
  return (
    <a
      href={`https://wa.me/${brand.phoneRaw}?text=Hello!%20I%20want%20to%20book%20a%20service.`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-30" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 text-white shadow-lg transition-colors">
        <MessageCircle className="w-7 h-7" fill="currentColor" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-white text-gray-800 text-sm font-medium px-3 py-1.5 rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us
      </span>
    </a>
  );
};

export default WhatsAppFloat;
